export interface ITooltipData {
  type?: 'sync' | 'async';
  calc?: string;
  content?: string | ITooltipContent;
}

export type TNvTooltipData = string | INvTooltipData;

interface INvTooltipData extends IStaticNvTooltipData, IAsyncNvTooltipData {}

interface IStaticNvTooltipData extends ICoreNvTooltipData {
  simpleContent?: string;
  tableContent?: ITooltipContent;
}

interface IAsyncNvTooltipData extends ICoreNvTooltipData {
  schoolId?: string;
  shelterId?: string;
  docId?: string;
  calc?: string; // graphqlKey for backend calc
  wildcard?: object;
}

interface ICoreNvTooltipData {
  connectedElType?: TTooltipElType; // if not provided, defaults to 'FIXED_OR_INFINITE_LIST_CELL' down stream
}

export type TTooltipElType = 'PANEL_FIELD' | 'FIXED_OR_INFINITE_LIST_CELL';

export interface ITooltipContent {
  headers?: Array<string>;
  rowData: Array<Array<string>>;
}

export function isTooltipContent(ttTest) {
  if (typeof ttTest !== 'object') return false;
  return (
    Object.keys(ttTest).includes('rowData') &&
    Array.isArray(ttTest.rowData) &&
    ttTest.rowData.every(row => Array.isArray(row)) &&
    ttTest.rowData.every(row => row.every(entry => typeof entry === 'string'))
  );
}
